import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_ESIM_UPSELL_CATALOG } from 'actions/apiActionConstants'
import requestLoyaltyEsimUpsellCatalog from 'api/loyalty/requestLoyaltyEsimUpsellCatalog'
import getObjectKey from 'lib/object/getObjectKey'

interface FetchLoyaltyEsimUpsellCatalogParams {
  countryCode: string
  currentPackageTicketId: App.LoyaltyEsimUpsellTicketId
  orderId?: string
}

interface LoyaltyEsimUpsellCatalogKeyParts {
  countryCode: string
  currencyCode: string
  customerId: string
  currentPackageTicketId: App.LoyaltyEsimUpsellTicketId
  orderId?: string
}

/**
 * @returns formatted catalog key e.g.
 * "orderId=ord-1;customerId=abc;currentPackageTicketId=3GB;currencyCode=AUD;countryCode=JP"
 */
export function getLoyaltyEsimUpsellCatalogKey(parts: LoyaltyEsimUpsellCatalogKeyParts): string {
  return getObjectKey(parts)
}

function fetchLoyaltyEsimUpsellCatalog({
  countryCode,
  currentPackageTicketId,
  orderId,
}: FetchLoyaltyEsimUpsellCatalogParams): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const customerId = state.auth.account.memberId
    const currencyCode = state.geo.currentCurrency

    if (!countryCode || !customerId) {
      return
    }

    const key = getLoyaltyEsimUpsellCatalogKey({
      countryCode,
      currencyCode,
      customerId,
      currentPackageTicketId,
      orderId,
    })
    const cached = state.loyalty.esimUpsellCatalogs[key]
    if (cached?.fetching || cached?.data) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_ESIM_UPSELL_CATALOG,
      key,
      request: () => requestLoyaltyEsimUpsellCatalog({
        countryCode,
        currencyCode,
        customerId,
        orderId,
      }),
    })
  }
}

export default fetchLoyaltyEsimUpsellCatalog
